import Chart from "chart.js/auto";
import { useEffect, useState } from "react";
import axios from "axios";
import { ArcElement } from "chart.js";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
} from "chart.js";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCol,
	IonDatetime,
	IonItem,
	IonLabel,
	IonSelect,
	IonSelectOption
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useStore from "../store/store";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

export const options = {
	responsive: true,
	plugins: {
		legend: {
			position: "top" as const
		}
	}
};

Chart.register(ArcElement);

const BarChart = (props: any) => {
	const { t } = useTranslation();
	const [year, setYear] = useState(moment().year());
	const { token } = useStore(state => state);

	const labels = [
		t("jan"),
		t("feb"),
		t("mar"),
		t("apr"),
		t("may"),
		t("jun"),
		t("jul"),
		t("aug"),
		t("sep"),
		t("oct"),
		t("nov"),
		t("dec")
	];

	const [data, setData] = useState({
		labels,
		datasets: [
			{
				label: t("income"),
				data: [],
				borderColor: "rgb(255, 205, 86)",
				backgroundColor: "rgba(255, 205, 86, 0.5)"
			},
			{
				label: t("expense"),
				data: [],
				borderColor: "rgb(54, 162, 235)",
				backgroundColor: "rgba(54, 162, 235, 0.5)"
			}
		]
	});

	const [years, setYears] = useState<number[]>([
		2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
	]);

	useEffect(() => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/transactions/yearly`,
				{
					year
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				setData({
					labels,
					datasets: [
						{
							label: t("income"),
							data: res.data.income,
							borderColor: "rgb(255, 205, 86)",
							backgroundColor: "rgb(255, 205, 86)"
						},
						{
							label: t("expense"),
							data: res.data.expense,
							borderColor: "rgb(54, 162, 235)",
							backgroundColor: "rgb(54, 162, 235)"
						}
					]
				});
			})
			.catch(err => console.log(err));
	}, [year]);

	return (
		<>
			<IonCol size="12">
				<IonCard>
					<IonCardHeader>
						<IonLabel style={{ fontSize: 20, fontWeight: "bold" }}>
							{t("cashflow")}
						</IonLabel>
						<IonItem
							style={{ maxWidth: 250, float: "right" }}
							lines="none"
						>
							<IonLabel position="floating">{t("year")}</IonLabel>
							<IonSelect
								placeholder={t("year") || ""}
								value={year}
								onIonChange={(e: any) =>
									setYear(e.target.value)
								}
								okText={t("ok") || "Yes"}
								cancelText={t("cancel") || "Cancel"}
							>
								{years.map((elem, index) => {
									return (
										<IonSelectOption
											value={elem}
											key={index}
										>
											{elem}
										</IonSelectOption>
									);
								})}
							</IonSelect>
						</IonItem>
					</IonCardHeader>
					<IonCardContent>
						<Bar options={options} data={data} />
					</IonCardContent>
				</IonCard>
			</IonCol>
		</>
	);
};

export default BarChart;
